import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

interface FontSizeProps {
  label?: string
  fontSize?: number
  mobileFontSize?: number
  onChange: (value: number) => void
  onChangeMobile: (value: number) => void
}

const FontSize = ({
  label,
  fontSize,
  mobileFontSize,
  onChangeMobile,
  onChange,
}: FontSizeProps) => {
  const { isMobile } = useDeviceModeContext()
  const update = (value: number) =>
    isMobile ? onChangeMobile(value) : onChange(value)
  const currentFontSize = isMobile ? mobileFontSize || fontSize : fontSize

  return (
    <RangeElement
      label={label}
      labelIcon={isMobile ? <MobileIconUi /> : undefined}
      value={currentFontSize}
      onChange={update}
      min={8}
    />
  )
}

export default FontSize
